import React from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import "../css/Buscador.css";

const BuscadorUsuarios = ({ search, setSearch }) => {
  return (
    <div className="buscador-usuarios align-center w-100">
      <FaMagnifyingGlass />
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Busca un usuario por DNI, nombre o apellido"
      />
    </div>
  );
};

export default BuscadorUsuarios;
